export const LOGIN = 'SCREEN_DETAIL_LOGIN_BUTTON';
export const TRAILER = 'SCREEN_DETAIL_TRAILER_BUTTON';
export const DOWNLOAD = 'SCREEN_DETAIL_DOWNLOAD_BUTTON';
export const PLAY = 'SCREEN_PLAYER_PLAY_BUTTON';
export const PLAY_DETAIL = 'SCREEN_DETAIL_WATCH_BUTTON';
export const HOVER_SEASON = 'HOVER_SEASON';
export const HOVER_EPISODE = 'HOVER_EPISODE';
export const BUTTON_CONTINUE_WATCHING = 'BUTTON_CONTINUE_WATCHING';

export const SCREEN_DETAIL_PROGRAM_SEASON_TAB_OTHER_EPISODE =
    'SCREEN_DETAIL_PROGRAM_SEASON_TAB_OTHER_EPISODE';
export const SCREEN_DETAIL_SEASONS_TAB_SELECTOR =
    'SCREEN_DETAIL_SEASONS_TAB_SELECTOR';
export const SCREEN_DETAIL_SEASON_TAB_SELECTOR =
    'SCREEN_DETAIL_SEASON_TAB_SELECTOR';

export const SCREEN_DETAIL_RECORD_BUTTON = 'SCREEN_DETAIL_RECORD_BUTTON';
export const SCREEN_DETAIL_CANCEL_BUTTON = 'SCREEN_DETAIL_CANCEL_BUTTON';

export const SCREEN_DETAIL_SERIES_CANCEL_SERIES_BUTTON =
    'SCREEN_DETAIL_SERIES_CANCEL_SERIES_BUTTON';
export const SCREEN_DETAIL_SERIES_CANCEL_EPISODE_BUTTON =
    'SCREEN_DETAIL_SERIES_CANCEL_EPISODE_BUTTON';
export const SCREEN_DETAIL_SERIES_RECORD_SERIES_BUTTON =
    'SCREEN_DETAIL_SERIES_RECORD_SERIES_BUTTON';
export const SCREEN_DETAIL_SERIES_RECORD_EPISODE_BUTTON =
    'SCREEN_DETAIL_SERIES_RECORD_EPISODE_BUTTON';
export const SCREEN_DETAIL_MANAGE_RECORDING_BUTTON =
    'SCREEN_DETAIL_MANAGE_RECORDING_BUTTON';
export const SCREEN_DETAIL_RECORDING_PROTECT_BUTTON =
    'SCREEN_DETAIL_RECORDING_PROTECT_BUTTON';
export const SCREEN_DETAIL_RECORDING_UNPROTECT_BUTTON =
    'SCREEN_DETAIL_RECORDING_UNPROTECT_BUTTON';
export const SCREEN_DETAIL_RECORDING_DELETE_BUTTON =
    'SCREEN_DETAIL_RECORDING_DELETE_BUTTON';
export const SCREEN_DETAIL_RECORD_SERIES_BUTTON =
    'SCREEN_DETAIL_RECORD_SERIES_BUTTON';
export const SCREEN_DETAIL_RECORDING_DELETE_SERIES_BUTTON =
    'SCREEN_DETAIL_RECORDING_DELETE_SERIES_BUTTON';
export const RECORDING_NOTIFICATION_SCHEDULED_STARTED =
    'RECORDING_NOTIFICATION_SCHEDULED_STARTED';
export const DELETED_EPISODE_NOTIFICATION_TITLE =
    'DELETED_EPISODE_NOTIFICATION_TITLE';
export const RECORDING_NOTIFICATION_SCHEDULED_STOPPED =
    'RECORDING_NOTIFICATION_SCHEDULED_STOPPED';
export const RECORDING_NOTIFICATION_SCHEDULED_CANCELLED =
    'RECORDING_NOTIFICATION_SCHEDULED_CANCELLED';
export const SCREEN_ALERT_CANCEL_SERIES_TITLE =
    'SCREEN_ALERT_CANCEL_SERIES_TITLE';
export const SCREEN_ALERT_CANCEL_SERIES_BODY =
    'SCREEN_ALERT_CANCEL_SERIES_BODY';
export const SCREEN_ALERT_CANCEL_SERIES_CANCEL_BUTTON =
    'SCREEN_ALERT_CANCEL_SERIES_CANCEL_BUTTON';
export const SCREEN_ALERT_CANCEL_SINGLE_RECORDING_TITLE =
    'SCREEN_ALERT_CANCEL_SINGLE_RECORDING_TITLE';
export const SCREEN_ALERT_CANCEL_EPISODE_TITLE =
    'SCREEN_ALERT_CANCEL_EPISODE_TITLE';
export const SCREEN_ALERT_CANCEL_EPISODE_BODY =
    'SCREEN_ALERT_CANCEL_EPISODE_BODY';
export const SCREEN_ALERT_CANCEL_SINGLE_RECORDING_BODY =
    'SCREEN_ALERT_CANCEL_SINGLE_RECORDING_BODY';
export const SCREEN_ALERT_CANCEL_EPISODE_CANCEL_BUTTON =
    'SCREEN_ALERT_CANCEL_EPISODE_CANCEL_BUTTON';
export const SCREEN_ALERT_QUOTA_EXCEEDED_TITLE =
    'SCREEN_ALERT_QUOTA_EXCEEDED_TITLE';
export const SCREEN_ALERT_QUOTA_EXCEEDED_BODY =
    'SCREEN_ALERT_QUOTA_EXCEEDED_BODY';
export const SCREEN_ALERT_DELETE_SERIES_RECORDING_TITLE =
    'SCREEN_ALERT_DELETE_SERIES_RECORDING_TITLE';
export const SCREEN_ALERT_DELETE_SERIES_RECORDING_BODY =
    'SCREEN_ALERT_DELETE_SERIES_RECORDING_BODY';
export const SCREEN_ALERT_DELETE_RECORDING_DELETE_SERIES_BUTTON =
    'SCREEN_ALERT_DELETE_RECORDING_DELETE_SERIES_BUTTON';
export const SCREEN_ALERT_DELETE_EPISODE_RECORDING_TITLE =
    'SCREEN_ALERT_DELETE_EPISODE_RECORDING_TITLE';
export const SCREEN_ALERT_DELETE_EPISODE_RECORDING_BODY =
    'SCREEN_ALERT_DELETE_EPISODE_RECORDING_BODY';
export const SCREEN_ALERT_DELETE_EPISODE_RECORDING_DELETE_BUTTON =
    'SCREEN_ALERT_DELETE_EPISODE_RECORDING_DELETE_BUTTON';
export const SCREEN_ALERT_DELETE_RECORDING_DELETE_BUTTON =
    'SCREEN_ALERT_DELETE_RECORDING_DELETE_BUTTON';
export const SCREEN_ALERT_DELETE_RECORDING_TITLE =
    'SCREEN_ALERT_DELETE_RECORDING_TITLE';
export const SCREEN_ALERT_DELETE_RECORDING_BODY =
    'SCREEN_ALERT_DELETE_RECORDING_BODY';

export const SCREEN_AUDIO_SUBTITLES_TITLE_GOT_IT_BUTTON =
    'SCREEN_AUDIO_SUBTITLES_TITLE_GOT_IT_BUTTON';
export const RECORDING_NOTIFICATION_SERIES_CANCELLED =
    'RECORDING_NOTIFICATION_SERIES_CANCELLED';
export const RECORDING_NOTIFICATION_SERIES_SCHEDULED =
    'RECORDING_NOTIFICATION_SERIES_SCHEDULED';
export const DELETED_NOTIFICATION_TITLE = 'DELETED_NOTIFICATION_TITLE';
export const PROTECTED_NOTIFICATION_TITLE = 'PROTECTED_NOTIFICATION_TITLE';
export const UNPROTECT_NOTIFICATION_TITLE = 'UNPROTECT_NOTIFICATION_TITLE';
export const RECORDING_NOTIFICATION_TIMEOUT = 'RECORDING_NOTIFICATION_TIMEOUT';
export const BUTTON_NO = 'BUTTON_NO';
export const SETTINGS_AUDIO_LANGUAGE = 'SETTINGS_AUDIO_LANGUAGE';
export const SCREEN_AUDIO_SUBTITLES_SUBTITLES =
    'SCREEN_AUDIO_SUBTITLES_SUBTITLES';

export const CLOSE_BUTTON = 'CLOSE_BUTTON';
export const ERR_A012_DETAIL_DISPLAY_ERROR = 'ERR_A012_DETAIL_DISPLAY_ERROR';
export const ERR_A012_DETAIL_DISPLAY_ERROR_DESC =
    'ERR_A012_DETAIL_DISPLAY_ERROR_DESC';
export const ERR_A014_DETAIL_DISPLAY_ERROR = 'ERR_A014_DETAIL_DISPLAY_ERROR';
export const ERR_A014_DETAIL_DISPLAY_ERROR_DESC =
    'ERR_A014_DETAIL_DISPLAY_ERROR_DESC';

export const SUBSCRIBE_OVERLAY_TITLE = 'SUBSCRIBE_OVERLAY_TITLE';
export const SUBSCRIBE_OVERLAY_DESCRIPTION_REACT_NATIVE =
    'SUBSCRIBE_OVERLAY_DESCRIPTION_REACT_NATIVE';
export const SELFCARE_APP_BUTTON = 'SELFCARE_APP_BUTTON';
export const SUBSCRIBE_OVERLAY_SELFCARE_LINK =
    'SUBSCRIBE_OVERLAY_SELFCARE_LINK';
export const RENT_OVERLAY_DESCRIPTION = 'RENT_OVERLAY_DESCRIPTION';
export const RENT_ERROR_TITLE = 'RENT_ERROR_TITLE';
export const RENT_ERROR_DESCRIPTION = 'RENT_ERROR_DESCRIPTION';
export const RENT_BUTTON = 'RENT_BUTTON';
export const OK_BUTTON = 'OK_BUTTON';
export const BUTTON_SUBSCRIBE = 'BUTTON_SUBSCRIBE';
export const BUTTON_RENT = 'BUTTON_RENT';

export const NON_INTERACTIVE_UI_SERVICE_ORDERED_TITLE =
    'NON_INTERACTIVE_UI_SERVICE_ORDERED_TITLE';
export const NON_INTERACTIVE_UI_SERVICE_ORDERED_DESCRIPTION_RN =
    'NON_INTERACTIVE_UI_SERVICE_ORDERED_DESCRIPTION_RN';

export const SCREEN_PLAYER_MANAGE_RECORDING_OVERLAY_TITLE =
    'SCREEN_PLAYER_MANAGE_RECORDING_OVERLAY_TITLE';
export const SERIES_NOTIFICATIONS = [
    RECORDING_NOTIFICATION_SERIES_SCHEDULED,
    RECORDING_NOTIFICATION_SERIES_CANCELLED,
    DELETED_NOTIFICATION_TITLE,
];

export const TVOD_RENT_GO_TO_WEB_TITLE = 'TVOD_RENT_GO_TO_WEB_TITLE';
export const TVOD_RENT_GO_TO_WEB_BODY = 'TVOD_RENT_GO_TO_WEB_BODY';

export const SUSPENSION_VOD_LIMIT_REACHED_TITLE =
    'SUSPENSION_VOD_LIMIT_REACHED_TITLE';
export const SUSPENSION_VOD_LIMIT_REACHED_DESCRIPTION =
    'SUSPENSION_VOD_LIMIT_REACHED_DESCRIPTION';

export const DETAIL_PAGE_PROGRAMS_TAB = 'DETAIL_PAGE_PROGRAMS_TAB';
export const DETAIL_PAGE_RECORDINGS_TAB = 'DETAIL_PAGE_RECORDINGS_TAB';
